import ReviewDashboard from '@/views/dictionary/review/ReviewDashboard.vue'
import ReviewList from '@/views/dictionary/review/ReviewList.vue'
import ReviewDetail from '@/views/dictionary/review/ReviewDetail.vue'
import ReviewReports from '@/views/dictionary/review/ReviewReports.vue'
import ReviewSetting from '@/views/dictionary/review/ReviewSetting.vue'
import ReviewParsers from '@/views/dictionary/review/ReviewParsers.vue'



export default [
    {
        path: '/reviews_monitor',
        name: 'reviews_monitor',
        component: ReviewDashboard,
        meta: {
            requiresAuth: true,
            requiresRule: true
        }
    },
    {
        path: '/reviews_monitor/reviews',
        name: 'reviews_monitor_reviews',
        component: ReviewList,
        meta: {
            requiresAuth: true,
            // requiresRule: true
        }
    },
    {
        path: '/reviews_monitor/parsers/:id',
        name: 'reviews_monitor_detail',
        component: ReviewDetail,
        meta: {
            requiresAuth: true,
            // requiresRule: true
        }
    },
    {
        path: '/reviews_monitor/parsers',
        name: 'reviews_monitor_parsers',
        component: ReviewParsers,
        meta: {
            requiresAuth: true,
            // requiresRule: true
        }
    },
    {
        path: '/reviews_monitor/reports',
        name: 'reviews_monitor_report',
        component: ReviewReports,
        meta: {
            requiresAuth: true,
            // requiresRule: true
        }
    },
    {
        path: '/reviews_monitor/settings',
        name: 'reviews_monitor_setting',
        component: ReviewSetting,
        meta: {
            requiresAuth: true,
            // requiresRule: true
        }
    },
]

